import { Ref, ref } from 'vue';

export interface TableStore {
  tableKey: Ref<number>;
  incrementTableKey: () => void;
}

const tableKey = ref<number>(0);

const useTableStore = (): TableStore => {
  const incrementTableKey = (): void => {
    tableKey.value++;
  };

  return {
    tableKey,
    incrementTableKey,
  };
};

export default useTableStore;
